import * as yup from "yup";
import { KarteContentMaxLength } from "../../../../consts/KarteContentMaxLength";

const validationSchema = yup.object({
  name: yup
    .string()
    .trim()
    .required("スタッフ名は必須です")
    .max(33, "スタッフ名は33文字以下でご入力ください"),
  comment: yup
    .string()
    .trim()
    .required("コメントを入力してください")
    .max(
      KarteContentMaxLength,
      `コメントは${KarteContentMaxLength}文字以下でご入力ください`,
    ),
});

export default validationSchema;
